import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  EditButton,
  DeleteButton,
  Filter,
  TextInput,
  DateInput, Pagination
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import {config} from "../../config";
import {authorized} from '../../authorized'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTableCell-head': {
      backgroundColor: theme.palette.background.paper,
      fontWeight: 600,
    },
    '& .MuiTableRow-root': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(10, 132, 255, 0.04)',
      },
    },
    '& .column-name': {
      maxWidth: '300px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  actions: {
    display: 'flex',
    '& button': {
      marginRight: theme.spacing(1),
    },
  },
}));

const QRCodeFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search Name" source="name" alwaysOn />
    <DateInput label="To date" source="created_at_to" />
    <DateInput label="From date" source="created_at_from" />
  </Filter>
);

const OMSPagination = props => <Pagination rowsPerPageOptions={[config.perPage]} {...props} />;

const QrCodeList = (props) => {
  const classes = useStyles();
  
  return (
    <List 
      {...props} 
      className={classes.root}
      filters={<QRCodeFilter />}
      perPage={config.perPage}
      sort={{ field: 'created_at', order: 'DESC' }}
      bulkActionButtons={false}
      exporter={false}
      pagination={<OMSPagination/>}
    >
      <Datagrid rowClick="show" optimized>
        <TextField source="name" className="column-name" />
        <TextField source="url" className="column-name" />
        <DateField source="created_at" showTime />
          {authorized.permissions.indexOf('product.qr_codes.get') !== -1 ? <ShowButton/> : <span/>}
          {authorized.permissions.indexOf('product.qr_codes.edit') !== -1 ? <EditButton/> : <span/>}
          {authorized.permissions.indexOf('product.qr_codes.delete') !== -1 ? <DeleteButton/> : <span/>}
      </Datagrid>
    </List>
  );
};

export default QrCodeList;